import { render } from "./PageLoading.vue?vue&type=template&id=06c0ac09&scoped=true&ts=true"
import script from "./PageLoading.vue?vue&type=script&lang=ts"
export * from "./PageLoading.vue?vue&type=script&lang=ts"

import "./PageLoading.vue?vue&type=style&index=0&id=06c0ac09&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06c0ac09"]])

export default __exports__